// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file products/v1/product.proto (package products.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Money, MoneyJson } from "../../google/type/money_pb";
import { file_google_type_money } from "../../google/type/money_pb";
import type { PostalAddress, PostalAddressJson } from "../../google/type/postal_address_pb";
import { file_google_type_postal_address } from "../../google/type/postal_address_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file products/v1/product.proto.
 */
export const file_products_v1_product: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_google_protobuf_timestamp, file_google_type_money, file_google_type_postal_address],
	);

/**
 * @generated from message products.v1.PaymentSettings
 */
export type PaymentSettings = Message<"products.v1.PaymentSettings"> & {
	/**
	 * @generated from field: repeated string accepted_card_brands = 1;
	 */
	acceptedCardBrands: string[];

	/**
	 * @generated from field: string card_vault_url = 2;
	 */
	cardVaultUrl: string;

	/**
	 * @generated from field: string country_code = 3;
	 */
	countryCode: string;

	/**
	 * @generated from field: string currency_code = 4;
	 */
	currencyCode: string;

	/**
	 * @generated from field: repeated string enabled_presentment_currencies = 5;
	 */
	enabledPresentmentCurrencies: string[];

	/**
	 * @generated from field: string payment_account_id = 6;
	 */
	paymentAccountId: string;

	/**
	 * @generated from field: repeated string supported_digital_wallets = 7;
	 */
	supportedDigitalWallets: string[];
};

/**
 * @generated from message products.v1.PaymentSettings
 */
export type PaymentSettingsJson = {
	/**
	 * @generated from field: repeated string accepted_card_brands = 1;
	 */
	acceptedCardBrands?: string[];

	/**
	 * @generated from field: string card_vault_url = 2;
	 */
	cardVaultUrl?: string;

	/**
	 * @generated from field: string country_code = 3;
	 */
	countryCode?: string;

	/**
	 * @generated from field: string currency_code = 4;
	 */
	currencyCode?: string;

	/**
	 * @generated from field: repeated string enabled_presentment_currencies = 5;
	 */
	enabledPresentmentCurrencies?: string[];

	/**
	 * @generated from field: string payment_account_id = 6;
	 */
	paymentAccountId?: string;

	/**
	 * @generated from field: repeated string supported_digital_wallets = 7;
	 */
	supportedDigitalWallets?: string[];
};

/**
 * Describes the message products.v1.PaymentSettings.
 * Use `create(PaymentSettingsSchema)` to create a new message.
 */
export const PaymentSettingsSchema: GenMessage<PaymentSettings, { jsonType: PaymentSettingsJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 0);

/**
 * @generated from message products.v1.Integration
 */
export type Integration = Message<"products.v1.Integration"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string integration_type = 2;
	 */
	integrationType: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * @generated from field: products.v1.Image logo = 6;
	 */
	logo?: Image | undefined;

	/**
	 * @generated from field: string url = 7;
	 */
	url: string;

	/**
	 * @generated from field: products.v1.PaymentSettings payment_settings = 10;
	 */
	paymentSettings?: PaymentSettings | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message products.v1.Integration
 */
export type IntegrationJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string integration_type = 2;
	 */
	integrationType?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: products.v1.Image logo = 6;
	 */
	logo?: ImageJson;

	/**
	 * @generated from field: string url = 7;
	 */
	url?: string;

	/**
	 * @generated from field: products.v1.PaymentSettings payment_settings = 10;
	 */
	paymentSettings?: PaymentSettingsJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message products.v1.Integration.
 * Use `create(IntegrationSchema)` to create a new message.
 */
export const IntegrationSchema: GenMessage<Integration, { jsonType: IntegrationJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 1);

/**
 * @generated from message products.v1.Image
 */
export type Image = Message<"products.v1.Image"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: int32 height = 2;
	 */
	height: number;

	/**
	 * @generated from field: int32 width = 3;
	 */
	width: number;

	/**
	 * @generated from field: string alt_text = 4;
	 */
	altText: string;
};

/**
 * @generated from message products.v1.Image
 */
export type ImageJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: int32 height = 2;
	 */
	height?: number;

	/**
	 * @generated from field: int32 width = 3;
	 */
	width?: number;

	/**
	 * @generated from field: string alt_text = 4;
	 */
	altText?: string;
};

/**
 * Describes the message products.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, { jsonType: ImageJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 2);

/**
 * @generated from message products.v1.Variant
 */
export type Variant = Message<"products.v1.Variant"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string sku = 2;
	 */
	sku: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title: string;

	/**
	 * @generated from field: products.v1.Image image = 4;
	 */
	image?: Image | undefined;

	/**
	 * @generated from field: google.type.Money compare_at_price = 12;
	 */
	compareAtPrice?: Money | undefined;

	/**
	 * @generated from field: google.type.Money price = 5;
	 */
	price?: Money | undefined;

	/**
	 * @generated from field: string barcode = 6;
	 */
	barcode: string;

	/**
	 * @generated from field: map<string, string> selected_options = 7;
	 */
	selectedOptions: { [key: string]: string };

	/**
	 * @generated from field: int64 quantity_available = 8;
	 */
	quantityAvailable: bigint;

	/**
	 * @generated from field: bool available_for_sale = 9;
	 */
	availableForSale: boolean;

	/**
	 * @generated from field: bool currently_not_in_stock = 10;
	 */
	currentlyNotInStock: boolean;

	/**
	 * @generated from field: bool requires_shipping = 11;
	 */
	requiresShipping: boolean;
};

/**
 * @generated from message products.v1.Variant
 */
export type VariantJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string sku = 2;
	 */
	sku?: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title?: string;

	/**
	 * @generated from field: products.v1.Image image = 4;
	 */
	image?: ImageJson;

	/**
	 * @generated from field: google.type.Money compare_at_price = 12;
	 */
	compareAtPrice?: MoneyJson;

	/**
	 * @generated from field: google.type.Money price = 5;
	 */
	price?: MoneyJson;

	/**
	 * @generated from field: string barcode = 6;
	 */
	barcode?: string;

	/**
	 * @generated from field: map<string, string> selected_options = 7;
	 */
	selectedOptions?: { [key: string]: string };

	/**
	 * @generated from field: int64 quantity_available = 8;
	 */
	quantityAvailable?: string;

	/**
	 * @generated from field: bool available_for_sale = 9;
	 */
	availableForSale?: boolean;

	/**
	 * @generated from field: bool currently_not_in_stock = 10;
	 */
	currentlyNotInStock?: boolean;

	/**
	 * @generated from field: bool requires_shipping = 11;
	 */
	requiresShipping?: boolean;
};

/**
 * Describes the message products.v1.Variant.
 * Use `create(VariantSchema)` to create a new message.
 */
export const VariantSchema: GenMessage<Variant, { jsonType: VariantJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 3);

/**
 * @generated from message products.v1.PriceRange
 */
export type PriceRange = Message<"products.v1.PriceRange"> & {
	/**
	 * @generated from field: google.type.Money min_variant_price = 1;
	 */
	minVariantPrice?: Money | undefined;

	/**
	 * @generated from field: google.type.Money max_variant_price = 2;
	 */
	maxVariantPrice?: Money | undefined;
};

/**
 * @generated from message products.v1.PriceRange
 */
export type PriceRangeJson = {
	/**
	 * @generated from field: google.type.Money min_variant_price = 1;
	 */
	minVariantPrice?: MoneyJson;

	/**
	 * @generated from field: google.type.Money max_variant_price = 2;
	 */
	maxVariantPrice?: MoneyJson;
};

/**
 * Describes the message products.v1.PriceRange.
 * Use `create(PriceRangeSchema)` to create a new message.
 */
export const PriceRangeSchema: GenMessage<PriceRange, { jsonType: PriceRangeJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 4);

/**
 * @generated from message products.v1.Rating
 */
export type Rating = Message<"products.v1.Rating"> & {
	/**
	 * @generated from field: float value = 1;
	 */
	value: number;

	/**
	 * @generated from field: float scale_min = 2;
	 */
	scaleMin: number;

	/**
	 * @generated from field: float scale_max = 3;
	 */
	scaleMax: number;
};

/**
 * @generated from message products.v1.Rating
 */
export type RatingJson = {
	/**
	 * @generated from field: float value = 1;
	 */
	value?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float scale_min = 2;
	 */
	scaleMin?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float scale_max = 3;
	 */
	scaleMax?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message products.v1.Rating.
 * Use `create(RatingSchema)` to create a new message.
 */
export const RatingSchema: GenMessage<Rating, { jsonType: RatingJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 5);

/**
 * @generated from message products.v1.Product
 */
export type Product = Message<"products.v1.Product"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string integration_id = 2;
	 */
	integrationId: string;

	/**
	 * @generated from field: string handle = 18;
	 */
	handle: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: products.v1.Image featured_image = 5;
	 */
	featuredImage?: Image | undefined;

	/**
	 * @generated from field: repeated products.v1.Image images = 6;
	 */
	images: Image[];

	/**
	 * @generated from field: products.v1.PriceRange compare_at_price_range = 13;
	 */
	compareAtPriceRange?: PriceRange | undefined;

	/**
	 * @generated from field: products.v1.PriceRange price_range = 7;
	 */
	priceRange?: PriceRange | undefined;

	/**
	 * @generated from field: repeated products.v1.Variant variants = 8;
	 */
	variants: Variant[];

	/**
	 * @generated from field: products.v1.Rating rating = 11;
	 */
	rating?: Rating | undefined;

	/**
	 * @generated from field: int64 rating_count = 12;
	 */
	ratingCount: bigint;

	/**
	 * @generated from field: int64 total_inventory = 14;
	 */
	totalInventory: bigint;

	/**
	 * @generated from field: string product_type = 15;
	 */
	productType: string;

	/**
	 * @generated from field: string online_store_url = 16;
	 */
	onlineStoreUrl: string;

	/**
	 * @generated from field: string vendor = 17;
	 */
	vendor: string;

	/**
	 * @generated from field: bool available_for_sale = 19;
	 */
	availableForSale: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message products.v1.Product
 */
export type ProductJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string integration_id = 2;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string handle = 18;
	 */
	handle?: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: products.v1.Image featured_image = 5;
	 */
	featuredImage?: ImageJson;

	/**
	 * @generated from field: repeated products.v1.Image images = 6;
	 */
	images?: ImageJson[];

	/**
	 * @generated from field: products.v1.PriceRange compare_at_price_range = 13;
	 */
	compareAtPriceRange?: PriceRangeJson;

	/**
	 * @generated from field: products.v1.PriceRange price_range = 7;
	 */
	priceRange?: PriceRangeJson;

	/**
	 * @generated from field: repeated products.v1.Variant variants = 8;
	 */
	variants?: VariantJson[];

	/**
	 * @generated from field: products.v1.Rating rating = 11;
	 */
	rating?: RatingJson;

	/**
	 * @generated from field: int64 rating_count = 12;
	 */
	ratingCount?: string;

	/**
	 * @generated from field: int64 total_inventory = 14;
	 */
	totalInventory?: string;

	/**
	 * @generated from field: string product_type = 15;
	 */
	productType?: string;

	/**
	 * @generated from field: string online_store_url = 16;
	 */
	onlineStoreUrl?: string;

	/**
	 * @generated from field: string vendor = 17;
	 */
	vendor?: string;

	/**
	 * @generated from field: bool available_for_sale = 19;
	 */
	availableForSale?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message products.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product, { jsonType: ProductJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 6);

/**
 * @generated from message products.v1.LineItem
 */
export type LineItem = Message<"products.v1.LineItem"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string variant_id = 2;
	 */
	variantId: string;

	/**
	 * @generated from field: int64 quantity = 3;
	 */
	quantity: bigint;
};

/**
 * @generated from message products.v1.LineItem
 */
export type LineItemJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string variant_id = 2;
	 */
	variantId?: string;

	/**
	 * @generated from field: int64 quantity = 3;
	 */
	quantity?: string;
};

/**
 * Describes the message products.v1.LineItem.
 * Use `create(LineItemSchema)` to create a new message.
 */
export const LineItemSchema: GenMessage<LineItem, { jsonType: LineItemJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 7);

/**
 * @generated from message products.v1.ShippingRate
 */
export type ShippingRate = Message<"products.v1.ShippingRate"> & {
	/**
	 * @generated from field: string handle = 1;
	 */
	handle: string;

	/**
	 * @generated from field: string title = 2;
	 */
	title: string;

	/**
	 * @generated from field: google.type.Money price = 3;
	 */
	price?: Money | undefined;
};

/**
 * @generated from message products.v1.ShippingRate
 */
export type ShippingRateJson = {
	/**
	 * @generated from field: string handle = 1;
	 */
	handle?: string;

	/**
	 * @generated from field: string title = 2;
	 */
	title?: string;

	/**
	 * @generated from field: google.type.Money price = 3;
	 */
	price?: MoneyJson;
};

/**
 * Describes the message products.v1.ShippingRate.
 * Use `create(ShippingRateSchema)` to create a new message.
 */
export const ShippingRateSchema: GenMessage<ShippingRate, { jsonType: ShippingRateJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 8);

/**
 * @generated from message products.v1.ShippingRates
 */
export type ShippingRates = Message<"products.v1.ShippingRates"> & {
	/**
	 * @generated from field: bool ready = 1;
	 */
	ready: boolean;

	/**
	 * @generated from field: repeated products.v1.ShippingRate shipping_rates = 2;
	 */
	shippingRates: ShippingRate[];
};

/**
 * @generated from message products.v1.ShippingRates
 */
export type ShippingRatesJson = {
	/**
	 * @generated from field: bool ready = 1;
	 */
	ready?: boolean;

	/**
	 * @generated from field: repeated products.v1.ShippingRate shipping_rates = 2;
	 */
	shippingRates?: ShippingRateJson[];
};

/**
 * Describes the message products.v1.ShippingRates.
 * Use `create(ShippingRatesSchema)` to create a new message.
 */
export const ShippingRatesSchema: GenMessage<ShippingRates, { jsonType: ShippingRatesJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 9);

/**
 * @generated from message products.v1.AmountDue
 */
export type AmountDue = Message<"products.v1.AmountDue"> & {
	/**
	 * @generated from field: google.type.Money line_item_subtotal_price = 2;
	 */
	lineItemSubtotalPrice?: Money | undefined;

	/**
	 * @generated from field: google.type.Money subtotal_price = 3;
	 */
	subtotalPrice?: Money | undefined;

	/**
	 * @generated from field: google.type.Money payment_due = 4;
	 */
	paymentDue?: Money | undefined;

	/**
	 * @generated from field: google.type.Money total_duties = 5;
	 */
	totalDuties?: Money | undefined;

	/**
	 * @generated from field: google.type.Money total_tax = 6;
	 */
	totalTax?: Money | undefined;

	/**
	 * @generated from field: google.type.Money total_price = 7;
	 */
	totalPrice?: Money | undefined;
};

/**
 * @generated from message products.v1.AmountDue
 */
export type AmountDueJson = {
	/**
	 * @generated from field: google.type.Money line_item_subtotal_price = 2;
	 */
	lineItemSubtotalPrice?: MoneyJson;

	/**
	 * @generated from field: google.type.Money subtotal_price = 3;
	 */
	subtotalPrice?: MoneyJson;

	/**
	 * @generated from field: google.type.Money payment_due = 4;
	 */
	paymentDue?: MoneyJson;

	/**
	 * @generated from field: google.type.Money total_duties = 5;
	 */
	totalDuties?: MoneyJson;

	/**
	 * @generated from field: google.type.Money total_tax = 6;
	 */
	totalTax?: MoneyJson;

	/**
	 * @generated from field: google.type.Money total_price = 7;
	 */
	totalPrice?: MoneyJson;
};

/**
 * Describes the message products.v1.AmountDue.
 * Use `create(AmountDueSchema)` to create a new message.
 */
export const AmountDueSchema: GenMessage<AmountDue, { jsonType: AmountDueJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 10);

/**
 * @generated from message products.v1.Checkout
 */
export type Checkout = Message<"products.v1.Checkout"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: bool ready = 2;
	 */
	ready: boolean;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId: string;

	/**
	 * @generated from field: string country_code = 4;
	 */
	countryCode: string;

	/**
	 * @generated from field: string currency_code = 5;
	 */
	currencyCode: string;

	/**
	 * @generated from field: string first_name = 6;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 7;
	 */
	lastName: string;

	/**
	 * @generated from field: string email = 8;
	 */
	email: string;

	/**
	 * @generated from field: string phone = 9;
	 */
	phone: string;

	/**
	 * @generated from field: repeated products.v1.LineItem line_items = 10;
	 */
	lineItems: LineItem[];

	/**
	 * @generated from field: google.type.PostalAddress shipping_address = 11;
	 */
	shippingAddress?: PostalAddress | undefined;

	/**
	 * @generated from field: bool requires_shipping = 12;
	 */
	requiresShipping: boolean;

	/**
	 * @generated from field: products.v1.ShippingRates available_shipping_rates = 13;
	 */
	availableShippingRates?: ShippingRates | undefined;

	/**
	 * @generated from field: products.v1.ShippingRate selected_shipping_rate = 14;
	 */
	selectedShippingRate?: ShippingRate | undefined;

	/**
	 * @generated from field: products.v1.AmountDue amount_due = 15;
	 */
	amountDue?: AmountDue | undefined;

	/**
	 * @generated from field: bool tax_exempt = 16;
	 */
	taxExempt: boolean;

	/**
	 * @generated from field: bool tax_included = 17;
	 */
	taxIncluded: boolean;

	/**
	 * @generated from field: string web_url = 18;
	 */
	webUrl: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 19;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 20;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp completed_at = 21;
	 */
	completedAt?: Timestamp | undefined;
};

/**
 * @generated from message products.v1.Checkout
 */
export type CheckoutJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: bool ready = 2;
	 */
	ready?: boolean;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string country_code = 4;
	 */
	countryCode?: string;

	/**
	 * @generated from field: string currency_code = 5;
	 */
	currencyCode?: string;

	/**
	 * @generated from field: string first_name = 6;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 7;
	 */
	lastName?: string;

	/**
	 * @generated from field: string email = 8;
	 */
	email?: string;

	/**
	 * @generated from field: string phone = 9;
	 */
	phone?: string;

	/**
	 * @generated from field: repeated products.v1.LineItem line_items = 10;
	 */
	lineItems?: LineItemJson[];

	/**
	 * @generated from field: google.type.PostalAddress shipping_address = 11;
	 */
	shippingAddress?: PostalAddressJson;

	/**
	 * @generated from field: bool requires_shipping = 12;
	 */
	requiresShipping?: boolean;

	/**
	 * @generated from field: products.v1.ShippingRates available_shipping_rates = 13;
	 */
	availableShippingRates?: ShippingRatesJson;

	/**
	 * @generated from field: products.v1.ShippingRate selected_shipping_rate = 14;
	 */
	selectedShippingRate?: ShippingRateJson;

	/**
	 * @generated from field: products.v1.AmountDue amount_due = 15;
	 */
	amountDue?: AmountDueJson;

	/**
	 * @generated from field: bool tax_exempt = 16;
	 */
	taxExempt?: boolean;

	/**
	 * @generated from field: bool tax_included = 17;
	 */
	taxIncluded?: boolean;

	/**
	 * @generated from field: string web_url = 18;
	 */
	webUrl?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 19;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 20;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp completed_at = 21;
	 */
	completedAt?: TimestampJson;
};

/**
 * Describes the message products.v1.Checkout.
 * Use `create(CheckoutSchema)` to create a new message.
 */
export const CheckoutSchema: GenMessage<Checkout, { jsonType: CheckoutJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 11);

/**
 * @generated from message products.v1.Order
 */
export type Order = Message<"products.v1.Order"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string checkout_id = 2;
	 */
	checkoutId: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId: string;

	/**
	 * @generated from field: string country_code = 4;
	 */
	countryCode: string;

	/**
	 * @generated from field: string currency_code = 5;
	 */
	currencyCode: string;

	/**
	 * @generated from field: string email = 6;
	 */
	email: string;

	/**
	 * @generated from field: string phone = 7;
	 */
	phone: string;

	/**
	 * @generated from field: string shipping_first_name = 8;
	 */
	shippingFirstName: string;

	/**
	 * @generated from field: string shipping_last_name = 9;
	 */
	shippingLastName: string;

	/**
	 * @generated from field: google.type.PostalAddress shipping_address = 10;
	 */
	shippingAddress?: PostalAddress | undefined;

	/**
	 * @generated from field: string billing_first_name = 11;
	 */
	billingFirstName: string;

	/**
	 * @generated from field: string billing_last_name = 12;
	 */
	billingLastName: string;

	/**
	 * @generated from field: google.type.PostalAddress billing_address = 13;
	 */
	billingAddress?: PostalAddress | undefined;

	/**
	 * @generated from field: repeated products.v1.LineItem line_items = 14;
	 */
	lineItems: LineItem[];

	/**
	 * @generated from field: products.v1.ShippingRate selected_shipping_rate = 15;
	 */
	selectedShippingRate?: ShippingRate | undefined;

	/**
	 * @generated from field: products.v1.AmountDue amount_due = 16;
	 */
	amountDue?: AmountDue | undefined;

	/**
	 * @generated from field: int64 order_number = 17;
	 */
	orderNumber: bigint;

	/**
	 * @generated from field: string status_url = 18;
	 */
	statusUrl: string;

	/**
	 * @generated from field: map<string, string> notes = 19;
	 */
	notes: { [key: string]: string };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 20;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 21;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message products.v1.Order
 */
export type OrderJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string checkout_id = 2;
	 */
	checkoutId?: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string country_code = 4;
	 */
	countryCode?: string;

	/**
	 * @generated from field: string currency_code = 5;
	 */
	currencyCode?: string;

	/**
	 * @generated from field: string email = 6;
	 */
	email?: string;

	/**
	 * @generated from field: string phone = 7;
	 */
	phone?: string;

	/**
	 * @generated from field: string shipping_first_name = 8;
	 */
	shippingFirstName?: string;

	/**
	 * @generated from field: string shipping_last_name = 9;
	 */
	shippingLastName?: string;

	/**
	 * @generated from field: google.type.PostalAddress shipping_address = 10;
	 */
	shippingAddress?: PostalAddressJson;

	/**
	 * @generated from field: string billing_first_name = 11;
	 */
	billingFirstName?: string;

	/**
	 * @generated from field: string billing_last_name = 12;
	 */
	billingLastName?: string;

	/**
	 * @generated from field: google.type.PostalAddress billing_address = 13;
	 */
	billingAddress?: PostalAddressJson;

	/**
	 * @generated from field: repeated products.v1.LineItem line_items = 14;
	 */
	lineItems?: LineItemJson[];

	/**
	 * @generated from field: products.v1.ShippingRate selected_shipping_rate = 15;
	 */
	selectedShippingRate?: ShippingRateJson;

	/**
	 * @generated from field: products.v1.AmountDue amount_due = 16;
	 */
	amountDue?: AmountDueJson;

	/**
	 * @generated from field: int64 order_number = 17;
	 */
	orderNumber?: string;

	/**
	 * @generated from field: string status_url = 18;
	 */
	statusUrl?: string;

	/**
	 * @generated from field: map<string, string> notes = 19;
	 */
	notes?: { [key: string]: string };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 20;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 21;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message products.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema: GenMessage<Order, { jsonType: OrderJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 12);

/**
 * @generated from message products.v1.PaymentInfo
 */
export type PaymentInfo = Message<"products.v1.PaymentInfo"> & {
	/**
	 * @generated from oneof products.v1.PaymentInfo.type
	 */
	type:
		| {
				/**
				 * @generated from field: products.v1.CreditCardPayment credit_card_payment = 1;
				 */
				value: CreditCardPayment;
				case: "creditCardPayment";
		  }
		| {
				/**
				 * @generated from field: products.v1.TokenizedPayment tokenized_payment = 2;
				 */
				value: TokenizedPayment;
				case: "tokenizedPayment";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: google.type.Money amount = 3;
	 */
	amount?: Money | undefined;

	/**
	 * @generated from field: string first_name = 4;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 5;
	 */
	lastName: string;

	/**
	 * @generated from field: optional string phone = 6;
	 */
	phone?: string | undefined;

	/**
	 * @generated from field: google.type.PostalAddress billing_address = 7;
	 */
	billingAddress?: PostalAddress | undefined;
};

/**
 * @generated from message products.v1.PaymentInfo
 */
export type PaymentInfoJson = {
	/**
	 * @generated from field: products.v1.CreditCardPayment credit_card_payment = 1;
	 */
	creditCardPayment?: CreditCardPaymentJson;

	/**
	 * @generated from field: products.v1.TokenizedPayment tokenized_payment = 2;
	 */
	tokenizedPayment?: TokenizedPaymentJson;

	/**
	 * @generated from field: google.type.Money amount = 3;
	 */
	amount?: MoneyJson;

	/**
	 * @generated from field: string first_name = 4;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 5;
	 */
	lastName?: string;

	/**
	 * @generated from field: optional string phone = 6;
	 */
	phone?: string;

	/**
	 * @generated from field: google.type.PostalAddress billing_address = 7;
	 */
	billingAddress?: PostalAddressJson;
};

/**
 * Describes the message products.v1.PaymentInfo.
 * Use `create(PaymentInfoSchema)` to create a new message.
 */
export const PaymentInfoSchema: GenMessage<PaymentInfo, { jsonType: PaymentInfoJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 13);

/**
 * @generated from message products.v1.CreditCard
 */
export type CreditCard = Message<"products.v1.CreditCard"> & {
	/**
	 * @generated from field: string brand = 1;
	 */
	brand: string;

	/**
	 * @generated from field: int32 expiry_month = 2;
	 */
	expiryMonth: number;

	/**
	 * @generated from field: int32 expiry_year = 3;
	 */
	expiryYear: number;

	/**
	 * @generated from field: string first_digits = 4;
	 */
	firstDigits: string;

	/**
	 * @generated from field: string last_digits = 5;
	 */
	lastDigits: string;

	/**
	 * @generated from field: string last_name = 6;
	 */
	lastName: string;

	/**
	 * @generated from field: string masked_number = 7;
	 */
	maskedNumber: string;
};

/**
 * @generated from message products.v1.CreditCard
 */
export type CreditCardJson = {
	/**
	 * @generated from field: string brand = 1;
	 */
	brand?: string;

	/**
	 * @generated from field: int32 expiry_month = 2;
	 */
	expiryMonth?: number;

	/**
	 * @generated from field: int32 expiry_year = 3;
	 */
	expiryYear?: number;

	/**
	 * @generated from field: string first_digits = 4;
	 */
	firstDigits?: string;

	/**
	 * @generated from field: string last_digits = 5;
	 */
	lastDigits?: string;

	/**
	 * @generated from field: string last_name = 6;
	 */
	lastName?: string;

	/**
	 * @generated from field: string masked_number = 7;
	 */
	maskedNumber?: string;
};

/**
 * Describes the message products.v1.CreditCard.
 * Use `create(CreditCardSchema)` to create a new message.
 */
export const CreditCardSchema: GenMessage<CreditCard, { jsonType: CreditCardJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 14);

/**
 * @generated from message products.v1.Payment
 */
export type Payment = Message<"products.v1.Payment"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string checkout_id = 2;
	 */
	checkoutId: string;

	/**
	 * @generated from field: bool ready = 3;
	 */
	ready: boolean;

	/**
	 * @generated from field: google.type.Money amount = 4;
	 */
	amount?: Money | undefined;

	/**
	 * @generated from field: google.type.PostalAddress billing_address = 5;
	 */
	billingAddress?: PostalAddress | undefined;

	/**
	 * @generated from field: products.v1.CreditCard credit_card = 6;
	 */
	creditCard?: CreditCard | undefined;

	/**
	 * @generated from field: products.v1.Transaction transaction = 7;
	 */
	transaction?: Transaction | undefined;

	/**
	 * @generated from field: string next_action_url = 8;
	 */
	nextActionUrl: string;

	/**
	 * @generated from field: string email = 9;
	 */
	email: string;

	/**
	 * @generated from field: string name = 10;
	 */
	name: string;

	/**
	 * @generated from field: optional string phone = 11;
	 */
	phone?: string | undefined;
};

/**
 * @generated from message products.v1.Payment
 */
export type PaymentJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string checkout_id = 2;
	 */
	checkoutId?: string;

	/**
	 * @generated from field: bool ready = 3;
	 */
	ready?: boolean;

	/**
	 * @generated from field: google.type.Money amount = 4;
	 */
	amount?: MoneyJson;

	/**
	 * @generated from field: google.type.PostalAddress billing_address = 5;
	 */
	billingAddress?: PostalAddressJson;

	/**
	 * @generated from field: products.v1.CreditCard credit_card = 6;
	 */
	creditCard?: CreditCardJson;

	/**
	 * @generated from field: products.v1.Transaction transaction = 7;
	 */
	transaction?: TransactionJson;

	/**
	 * @generated from field: string next_action_url = 8;
	 */
	nextActionUrl?: string;

	/**
	 * @generated from field: string email = 9;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 10;
	 */
	name?: string;

	/**
	 * @generated from field: optional string phone = 11;
	 */
	phone?: string;
};

/**
 * Describes the message products.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema: GenMessage<Payment, { jsonType: PaymentJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 15);

/**
 * @generated from message products.v1.Transaction
 */
export type Transaction = Message<"products.v1.Transaction"> & {
	/**
	 * @generated from field: products.v1.TransactionKind kind = 1;
	 */
	kind: TransactionKind;

	/**
	 * @generated from field: products.v1.TransactionStatus status = 3;
	 */
	status: TransactionStatus;

	/**
	 * @generated from field: google.type.Money amount = 2;
	 */
	amount?: Money | undefined;
};

/**
 * @generated from message products.v1.Transaction
 */
export type TransactionJson = {
	/**
	 * @generated from field: products.v1.TransactionKind kind = 1;
	 */
	kind?: TransactionKindJson;

	/**
	 * @generated from field: products.v1.TransactionStatus status = 3;
	 */
	status?: TransactionStatusJson;

	/**
	 * @generated from field: google.type.Money amount = 2;
	 */
	amount?: MoneyJson;
};

/**
 * Describes the message products.v1.Transaction.
 * Use `create(TransactionSchema)` to create a new message.
 */
export const TransactionSchema: GenMessage<Transaction, { jsonType: TransactionJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 16);

/**
 * @generated from message products.v1.CreditCardPayment
 */
export type CreditCardPayment = Message<"products.v1.CreditCardPayment"> & {
	/**
	 * @generated from field: string card_vault_url = 1;
	 */
	cardVaultUrl: string;
};

/**
 * @generated from message products.v1.CreditCardPayment
 */
export type CreditCardPaymentJson = {
	/**
	 * @generated from field: string card_vault_url = 1;
	 */
	cardVaultUrl?: string;
};

/**
 * Describes the message products.v1.CreditCardPayment.
 * Use `create(CreditCardPaymentSchema)` to create a new message.
 */
export const CreditCardPaymentSchema: GenMessage<CreditCardPayment, { jsonType: CreditCardPaymentJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 17);

/**
 * @generated from message products.v1.TokenizedPayment
 */
export type TokenizedPayment = Message<"products.v1.TokenizedPayment"> & {
	/**
	 * @generated from field: products.v1.TokenizedPaymentType type = 1;
	 */
	type: TokenizedPaymentType;

	/**
	 * @generated from field: string payment_data = 2;
	 */
	paymentData: string;

	/**
	 * @generated from field: string identifier = 3;
	 */
	identifier: string;
};

/**
 * @generated from message products.v1.TokenizedPayment
 */
export type TokenizedPaymentJson = {
	/**
	 * @generated from field: products.v1.TokenizedPaymentType type = 1;
	 */
	type?: TokenizedPaymentTypeJson;

	/**
	 * @generated from field: string payment_data = 2;
	 */
	paymentData?: string;

	/**
	 * @generated from field: string identifier = 3;
	 */
	identifier?: string;
};

/**
 * Describes the message products.v1.TokenizedPayment.
 * Use `create(TokenizedPaymentSchema)` to create a new message.
 */
export const TokenizedPaymentSchema: GenMessage<TokenizedPayment, { jsonType: TokenizedPaymentJson }> = /*@__PURE__*/ messageDesc(file_products_v1_product, 18);

/**
 * @generated from enum products.v1.TransactionKind
 */
export enum TransactionKind {
	/**
	 * @generated from enum value: TRANSACTION_KIND_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRANSACTION_KIND_AUTHORIZATION = 1;
	 */
	AUTHORIZATION = 1,

	/**
	 * @generated from enum value: TRANSACTION_KIND_CAPTURE = 2;
	 */
	CAPTURE = 2,

	/**
	 * @generated from enum value: TRANSACTION_KIND_CHANGE = 3;
	 */
	CHANGE = 3,

	/**
	 * @generated from enum value: TRANSACTION_KIND_EMV_AUTHORIZATION = 4;
	 */
	EMV_AUTHORIZATION = 4,

	/**
	 * @generated from enum value: TRANSACTION_KIND_SALE = 5;
	 */
	SALE = 5,
}

/**
 * @generated from enum products.v1.TransactionKind
 */
export type TransactionKindJson = "TRANSACTION_KIND_UNSPECIFIED" | "TRANSACTION_KIND_AUTHORIZATION" | "TRANSACTION_KIND_CAPTURE" | "TRANSACTION_KIND_CHANGE" | "TRANSACTION_KIND_EMV_AUTHORIZATION" | "TRANSACTION_KIND_SALE";

/**
 * Describes the enum products.v1.TransactionKind.
 */
export const TransactionKindSchema: GenEnum<TransactionKind, TransactionKindJson> = /*@__PURE__*/ enumDesc(file_products_v1_product, 0);

/**
 * @generated from enum products.v1.TransactionStatus
 */
export enum TransactionStatus {
	/**
	 * @generated from enum value: TRANSACTION_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRANSACTION_STATUS_ERROR = 1;
	 */
	ERROR = 1,

	/**
	 * @generated from enum value: TRANSACTION_STATUS_FAILURE = 2;
	 */
	FAILURE = 2,

	/**
	 * @generated from enum value: TRANSACTION_STATUS_PENDING = 3;
	 */
	PENDING = 3,

	/**
	 * @generated from enum value: TRANSACTION_STATUS_SUCCESS = 4;
	 */
	SUCCESS = 4,
}

/**
 * @generated from enum products.v1.TransactionStatus
 */
export type TransactionStatusJson = "TRANSACTION_STATUS_UNSPECIFIED" | "TRANSACTION_STATUS_ERROR" | "TRANSACTION_STATUS_FAILURE" | "TRANSACTION_STATUS_PENDING" | "TRANSACTION_STATUS_SUCCESS";

/**
 * Describes the enum products.v1.TransactionStatus.
 */
export const TransactionStatusSchema: GenEnum<TransactionStatus, TransactionStatusJson> = /*@__PURE__*/ enumDesc(file_products_v1_product, 1);

/**
 * @generated from enum products.v1.TokenizedPaymentType
 */
export enum TokenizedPaymentType {
	/**
	 * @generated from enum value: TOKENIZED_PAYMENT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TOKENIZED_PAYMENT_TYPE_APPLE_PAY = 1;
	 */
	APPLE_PAY = 1,

	/**
	 * @generated from enum value: TOKENIZED_PAYMENT_TYPE_GOOGLE_PAY = 2;
	 */
	GOOGLE_PAY = 2,

	/**
	 * @generated from enum value: TOKENIZED_PAYMENT_TYPE_SHOPIFY_PAY = 3;
	 */
	SHOPIFY_PAY = 3,

	/**
	 * @generated from enum value: TOKENIZED_PAYMENT_TYPE_STRIPE_VAULT_TOKEN = 4;
	 */
	STRIPE_VAULT_TOKEN = 4,

	/**
	 * @generated from enum value: TOKENIZED_PAYMENT_TYPE_VAULT = 5;
	 */
	VAULT = 5,
}

/**
 * @generated from enum products.v1.TokenizedPaymentType
 */
export type TokenizedPaymentTypeJson = "TOKENIZED_PAYMENT_TYPE_UNSPECIFIED" | "TOKENIZED_PAYMENT_TYPE_APPLE_PAY" | "TOKENIZED_PAYMENT_TYPE_GOOGLE_PAY" | "TOKENIZED_PAYMENT_TYPE_SHOPIFY_PAY" | "TOKENIZED_PAYMENT_TYPE_STRIPE_VAULT_TOKEN" | "TOKENIZED_PAYMENT_TYPE_VAULT";

/**
 * Describes the enum products.v1.TokenizedPaymentType.
 */
export const TokenizedPaymentTypeSchema: GenEnum<TokenizedPaymentType, TokenizedPaymentTypeJson> = /*@__PURE__*/ enumDesc(file_products_v1_product, 2);
